(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    if ($('.featured-product-section') && $('.featured-product-section').length > 0) {
      
      document.querySelectorAll(".featured-product-section .product__media-list").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true,
          on: {
            select: function (index) {
              let slides = $(".featured-product-section .product__media-list .product__media-item");
    
              var iframe = $(slides[index]).find("iframe");
    
              var allIframes = document.querySelectorAll(".featured-product-section .product__media-list iframe");
              //var allIframes = $(".featured-product-section .product__media-list").find("iframe");
              var video = $(slides[index]).find("video");
              var allVideos = $(".featured-product-section .product__media-list").find("video");
    
              if (video && video.length > 0) {
                video.get(0).play();
              } else if (allVideos && allVideos.length > 0) {
                allVideos.get(0).pause();
              }
    
              if (iframe && iframe.length > 0) {
                iframe[0].contentWindow.postMessage(
                  JSON.stringify({ event: "command", func: "playVideo" }),
                  "*",
                );
              } else if (allIframes && allIframes.length > 0) {
                allIframes.forEach(video => {
                  if (video.classList.contains('js-youtube')) {
                    video.contentWindow.postMessage(
                      JSON.stringify({ event: "command", func: "pauseVideo" }),
                      "*",
                    );
                  }
                  else {
                    video.contentWindow.postMessage('{"method":"pause"}', "*");
                  }
                })
              } else {
                return false;
              }
            },
          },
        });

        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_prev').addEventListener( 'click', function() {
          slider.previous();
        });
        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_next').addEventListener( 'click', function() {
          slider.next();
        });
      });

      document.querySelectorAll(".featured-product-section .product__media-sublist").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          asNavFor: $(".featured-product-section .product__media-list")[index],
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          cellAlign: "left",
        })
      });
    }
  })

  document.addEventListener("shopify:section:load", function () {
     if (document.querySelectorAll('.featured-product-section').length > 0) {
      let $flickityElems = document.querySelectorAll(".featured-product-section .product__media-list.flickity-enabled");
      $flickityElems.forEach(($elem) => {
        Flickity.data($elem).destroy();
      });

      document.querySelectorAll(".featured-product-section .product__media-list").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true,
          on: {
            select: function (index) {
              let slides = $(".featured-product-section .product__media-list .product__media-item");
    
              var iframe = $(slides[index]).find("iframe");
    
              var allIframes = document.querySelectorAll(".featured-product-section .product__media-list iframe");
              //var allIframes = $(".featured-product-section .product__media-list").find("iframe");
              var video = $(slides[index]).find("video");
              var allVideos = $(".featured-product-section .product__media-list").find("video");
    
              if (video && video.length > 0) {
                video.get(0).play();
              } else if (allVideos && allVideos.length > 0) {
                allVideos.get(0).pause();
              }
    
              if (iframe && iframe.length > 0) {
                iframe[0].contentWindow.postMessage(
                  JSON.stringify({ event: "command", func: "playVideo" }),
                  "*",
                );
              } else if (allIframes && allIframes.length > 0) {
                allIframes.forEach(video => {
                  if (video.classList.contains('js-youtube')) {
                    video.contentWindow.postMessage(
                      JSON.stringify({ event: "command", func: "pauseVideo" }),
                      "*",
                    );
                  }
                  else {
                    video.contentWindow.postMessage('{"method":"pause"}', "*");
                  }
                })
              } else {
                return false;
              }
            },
          },
        });

        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_prev').addEventListener( 'click', function() {
          slider.previous();
        });
        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_next').addEventListener( 'click', function() {
          slider.next();
        });
      });

      document.querySelectorAll(".featured-product-section .product__media-sublist").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          asNavFor: $(".featured-product-section .product__media-list")[index],
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          cellAlign: "left",
        })
      });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();

    // Wait briefly for the modal to be fully visible in the DOM
    setTimeout(() => {
      // Grab all images that have data-zoom-image
      const imagesToZoom = this.querySelectorAll('img[data-zoom-image]');

      imagesToZoom.forEach(img => {
        // If the image is already fully loaded, init immediately.
        // Otherwise, attach an "load" event listener.
        if (img.complete) {
          initZoomOnImage(img);
        } else {
          // Wait for the actual image to load before .ezPlus()
          img.addEventListener('load', function onLoadHandler() {
            // Remove this one-time listener
            img.removeEventListener('load', onLoadHandler);
            initZoomOnImage(img);
          });
        }
      });

      // Helper function to remove old data and init ezPlus
      function initZoomOnImage(img) {
        // remove any old data
        $(img).removeData('ezPlus');
        $('.zoomContainer[uuid]').remove();

        // Now initialize ezPlus
        $(img).ezPlus({
          zoomType: 'lens',
          lensShape: 'round',
          lensSize: 200,
          lensBorderSize: 1,
          lensBorderColour: '#000', // 1px black border
          scrollZoom: false,        // disable mousewheel zoom
          zoomContainerAppendTo: '.product-media-modal__content'
        });
      }
    }, 150);
  }

  showActiveMedia() {
    // Deactivate everything except the target
    const notActive = `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`;
    this.querySelectorAll(notActive).forEach(el => el.classList.remove('active'));

    // Activate the correct media and scroll to it
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    if (activeMedia) {
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      // If it's a YouTube iframe or similar, load content
      if (
        activeMedia.nodeName === 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }
}

  
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations--single');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

$(document).ready(function () {
  if ($('.product-section') && $('.product-section').length > 0) {

    // For each main image carousel
    document.querySelectorAll(".product-section .product__media-list").forEach((elem, index) => {
      var slider = new Flickity(elem, {
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        wrapAround: true,
        on: {
          select: function (index) {
            let slides = $(".product-section .product__media-list .product__media-item");

            var iframe = $(slides[index]).find("iframe");
            var allIframes = document.querySelectorAll(".product-section .product__media-list iframe");
            var video = $(slides[index]).find("video");
            var allVideos = $(".product-section .product__media-list").find("video");

            // Play/pause logic
            if (video && video.length > 0) {
              video.get(0).play();
            } else if (allVideos && allVideos.length > 0) {
              allVideos.get(0).pause();
            }

            if (iframe && iframe.length > 0) {
              if (iframe[0].classList.contains('js-youtube')) {
                iframe[0].contentWindow.postMessage(
                  JSON.stringify({ event: "command", func: "playVideo" }),
                  "*"
                );
              } else {
                iframe[0].contentWindow.postMessage('{"method":"play"}', "*");
              }
            } else if (allIframes && allIframes.length > 0) {
              allIframes.forEach(video => {
                if (video.classList.contains('js-youtube')) {
                  video.contentWindow.postMessage(
                    JSON.stringify({ event: "command", func: "pauseVideo" }),
                    "*"
                  );
                } else {
                  video.contentWindow.postMessage('{"method":"pause"}', "*");
                }
              });
            } else {
              return false;
            }
          },
        },
      });

      // Prev arrow
      elem.parentElement
        .querySelector('.product-section .product__media-list-wrapper-outer-arrow_prev')
        .addEventListener('click', function() {
          slider.previous();
        });
      // Next arrow
      elem.parentElement
        .querySelector('.product-section .product__media-list-wrapper-outer-arrow_next')
        .addEventListener('click', function() {
          slider.next();
        });
    });

    // For each sublist (thumbnails) - as nav for main
    document.querySelectorAll(".product-section .product__media-sublist").forEach((elem, index) => {
      var slider = new Flickity(elem, {
        asNavFor: document.querySelectorAll(".product-section .product__media-list")[index],
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: "left"
      });
    });

    /*
    // Example jQuery Flickity:
    $('.product__media-list').flickity({
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      wrapAround: true,
      on: {
        select: function(index) {
          ...
        }
      }
    });
    */
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
